import React from 'react'
import { Helmet } from 'react-helmet-async'
import { CONTACT, LOCATIONS, SITE_NAME, SITE_URL } from './siteConfig'

const SOCIAL_PROFILES = [
  'https://www.facebook.com/ccchoreographydance',
  'https://www.instagram.com/cc.choreography/',
  'https://www.instagram.com/cc.choreography.adults/',
]

function locationToSchema(loc) {
  return {
    '@type': 'Place',
    name: loc.name,
    address: {
      '@type': 'PostalAddress',
      streetAddress: loc.streetAddress,
      addressLocality: loc.addressLocality,
      addressRegion: loc.addressRegion,
      postalCode: loc.postalCode,
      addressCountry: loc.addressCountry,
    },
  }
}

const LocalBusinessJsonLd = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'DanceSchool',
    name: SITE_NAME,
    url: SITE_URL,
    email: CONTACT.email,
    telephone: CONTACT.phone,
    image: `${SITE_URL}/apple-touch-icon.png`,
    description:
      'Kids and teen dance classes in Newcastle NSW. Studios in Hamilton North and Lambton offering ballet, jazz, hip hop, acro, musical theatre and Lil Groovers for ages 2–5.',
    areaServed: [
      { '@type': 'City', name: 'Newcastle', containedInPlace: { '@type': 'State', name: 'New South Wales' } },
      { '@type': 'Place', name: 'Hamilton North' },
      { '@type': 'Place', name: 'Lambton' },
    ],
    sameAs: SOCIAL_PROFILES,
    location: LOCATIONS.map(locationToSchema),
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Dance classes',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Kids dance classes' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Lil Groovers (ages 2–5)' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Ballet, jazz, hip hop, tap, acro' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Free trial week for new students' } },
      ],
    },
  }

  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(schema)}</script>
    </Helmet>
  )
}

export default LocalBusinessJsonLd
